module.exports = "https://coursera_assets.s3.amazonaws.com/images/6550f3d8717fd9a3a24ea57207c14a13.png";